<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
        {{ modalLabel }}
      </div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form
      id="frmProjectCreate"
      [formGroup]="adminOrganizationForm"
      (keydown.enter)="$event.preventDefault()"
    >
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <div class="services-form">
              <input
                type="text"
                formControlName="organizationName"
                placeholder="Organization Name"
              />
              <label>Organization name</label>
              <div
                *ngIf="
                  (adminOrganizationForm.controls['organizationName'].touched || submitted) &&
                  adminOrganizationForm.controls['organizationName'].errors
                "
              >
                <div
                  *ngIf="adminOrganizationForm.controls['organizationName'].errors?.['required'] || adminOrganizationForm.controls['organizationName'].errors?.['pattern']"
                  class="input-error"
                >
                  Organization name is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                adminOrganizationForm.get('licenseType')?.value ||
                adminOrganizationForm.get('licenseLevel')?.value
              "
              class="sub-header-drpdown pb-2"
              >License type</label
            >
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              #licenseTypeSelect
              [items]="licenseTypeList"
              [searchable]="false"
              formControlName="licenseType"
              bindLabel="name"
              bindValue="id"
              (change)="onLicenseTypeChange($event)"
              placeholder="License type *"
              required
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="licenseTypeSelect.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || adminOrganizationForm.controls['licenseType']?.touched) &&
                adminOrganizationForm.controls['licenseType']?.invalid
              "
              class="input-error"
            >
              License type is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                adminOrganizationForm.get('licenseLevel')?.value ||
                adminOrganizationForm.get('licenseType')?.value
              "
              class="sub-header-drpdown pb-2"
              >License level</label
            >
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              #licenseLevelSelect
              [items]="rangeList"
              [searchable]="false"
              formControlName="licenseLevel"
              bindLabel="levelName"
              bindValue="id"
              placeholder="License level *"
              required
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="licenseLevelSelect.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.levelName }}">
                  {{ item.levelName }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || adminOrganizationForm.controls['licenseLevel']?.touched) &&
                adminOrganizationForm.controls['licenseLevel']?.invalid
              "
              class="input-error"
            >
              License level is required.
            </div>
            <div *ngIf="licenseUpdatedFlag">
              <span class="normal-text"
                >System has auto updated from <span class="text-brand">{{ selectedName }}</span> to
                <span class="text-brand">{{ matchingName }}</span
                >.</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
            <label class="sub-header-drpdown pb-2">License duration</label>
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              #licenseDurationSelect
              [items]="durationList"
              [searchable]="false"
              [readonly]="isLicenseDurationDisabled"
              formControlName="licenseDuration"
              bindLabel="name"
              bindValue="id"
              placeholder="License duration"
              (change)="onDurationChange($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="licenseDurationSelect.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required" style="position: relative">
            <div class="ngbdate">
              <label *ngIf="startDateInput" class="sub-header-drpdown pb-2">Start date</label>
              <label
                *ngIf="expiryDateInput"
                style="visibility: hidden"
                class="sub-header-drpdown pb-2"
                >Holder_text</label
              >
              <input
                type="text"
                [bsConfig]="organizarionBsConfig"
                #hiddenStart
                [(ngModel)]="startDateInput"
                formControlName="startDate"
                [readonly]="true"
                (ngModelChange)="dateChange($event)"
                bsDatepicker
                placeholder="Start date *"
                placement="bottom"
              />
              <div
                [ngClass]="
                  expiryDateInput || startDateInput
                    ? 'input-group-append-organization'
                    : 'input-group-append'
                "
              >
                <span class="input-group-text">
                  <img
                    (click)="hiddenStart.click()"
                    src="assets/icons/calendar.svg"
                    width="16"
                    height="16"
                  />
                </span>
              </div>
            </div>
            <div class="services-form">
              <div
                *ngIf="(submitted || adminOrganizationForm.controls['startDate'].touched) && (adminOrganizationForm.controls['startDate'].errors?.['required'] || adminOrganizationForm.controls['startDate'].status === 'INVALID'  )"
              >
                <div
                  *ngIf="adminOrganizationForm.controls['startDate'].errors?.['required'] || adminOrganizationForm.controls['startDate'].status === 'INVALID'  "
                  class="input-error"
                >
                  Start date is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required" style="position: relative">
            <div class="ngbdate">
              <label *ngIf="expiryDateInput" class="sub-header-drpdown pb-2">Expiry date</label>
              <label
                *ngIf="startDateInput"
                style="visibility: hidden"
                class="sub-header-drpdown pb-2"
                >Holder_Text</label
              >
              <input
                type="text"
                [bsConfig]="organizarionBsConfigExp"
                #hiddenExpry
                [minDate]="minDate"
                formControlName="expiryDate"
                (ngModelChange)="dateChangeForExp($event)"
                [(ngModel)]="expiryDateInput"
                bsDatepicker
                placeholder="Expiry date *"
                [readonly]="true"
              />
              <div
                [ngClass]="
                  expiryDateInput || startDateInput
                    ? 'input-group-append-organization'
                    : 'input-group-append'
                "
              >
                <span class="input-group-text">
                  <img
                    (click)="hiddenExpry.click()"
                    src="assets/icons/calendar.svg"
                    width="16"
                    height="16"
                  />
                </span>
              </div>
            </div>
            <div class="services-form">
              <div
                *ngIf="(submitted || adminOrganizationForm.controls['expiryDate'].touched) && (adminOrganizationForm.controls['expiryDate'].errors?.['required'] || adminOrganizationForm.controls['expiryDate'].status === 'INVALID') "
              >
                <div
                  *ngIf="( adminOrganizationForm.controls['expiryDate'].status === 'INVALID' &&  !adminOrganizationForm.controls['expiryDate']
                                              .errors?.['ngbDate']?.minDate )"
                  class="input-error"
                >
                  Expiry date is required
                </div>
              </div>
              <div
                *ngIf="isShowDateInvalid ||  adminOrganizationForm.controls['expiryDate']
                                                      .errors?.['ngbDate']?.minDate"
                class="input-error"
              >
                Please select expiry date greater than start date.
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group required">
            <label
              *ngIf="expiryDateInput || startDateInput"
              style="visibility: hidden"
              class="sub-header-drpdown pb-2"
              >Text</label
            >
            <div class="services-form">
              <input
                type="number"
                formControlName="noOfLicence"
                maxlength="6"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                placeholder="No.of licenses"
                [(ngModel)]="userCount"
              />
              <label>No. of licenses</label>
              <div *ngIf="submitted">
                <div
                  *ngIf="adminOrganizationForm.controls['noOfLicence'].value === 0"
                  class="input-error"
                >
                  The number of licenses must be greater than 0
                </div>
              </div>
              <div
                *ngIf="
                  (submitted || adminOrganizationForm.controls['noOfLicence'].touched) &&
                  adminOrganizationForm.controls['noOfLicence'].errors
                "
              >
                <div
                  *ngIf="adminOrganizationForm.controls['noOfLicence'].errors?.['required'] "
                  class="input-error"
                >
                  No. of licenses is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="organizationLable"
              >Organization logo (Logos must be no wider than 250px per 80px of height and should be
              either in JPG or PNG or JPEG format only)</label
            >
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <piqet-angular-file-upload
            #fileUploadComponent
            type="image"
            [customConfig]="{
              placeholderText: 'Select image',
              customErrorMessage:
                'Only .jpg, .png, .jpeg files allowed. Image should be 250x80 px or smaller.',
              maxFileSize: 5,
              maxWidth: 250,
              maxHeight: 80,
              validateDimensions: true,
              showPreview: false
            }"
            [customClass]="'col-sm-12'"
            [existingFileUrl]="getImage"
            [existingFileName]="selectedFiles"
            [isImageValid]="isImageValid"
            (fileSelected)="onFileSelected($event)"
            (removeConfirmation)="deleteConfirmation()"
          ></piqet-angular-file-upload>
        </div>

        <div class="col-sm-3" *ngIf="imageUrl || getImage">
          <div class="image-preview-container">
            <div class="image-preview-wrapper position-relative">
              <div
                class="cross-position position-absolute"
                style="top: 5px; right: 5px; z-index: 10; cursor: pointer"
                (click)="deleteConfirmation()"
              >
                <img
                  src="./assets/icons/pop-up-cross.svg"
                  class="cross-icon"
                  width="15"
                  height="15"
                />
              </div>
              <img
                [src]="imageUrl || getImage"
                width="200"
                height="100"
                class="preview-image img-thumbnail"
                style="max-width: 100%; height: auto"
                alt="Organization Logo Preview"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Authorization Checkbox Row -->
      <div class="row mt-4">
        <div class="col-sm-12">
          <div class="d-flex align-items-center">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  type="checkbox"
                  class="chkOverview"
                  [checked]="isLogoConsented"
                  (change)="updateConsent($event)"
                />
              </div>
              <div>
                <span class="checkbox-style switch-cost"
                  >Authorize organization to be recognized as a PIQET user</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <div class="form-group"></div>
        </div>
        <div class="col-sm-8">
          <div class="form-group"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <div class="services-form">
              <input type="text " formControlName="baseUrl" placeholder="baseUrl " />
              <label>Base image url</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <label
              *ngIf="adminOrganizationForm.get('country')?.value"
              class="sub-header-drpdown pb-2"
              >Country</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #select
              [items]="countryList"
              [searchable]="false"
              formControlName="country"
              bindLabel="name"
              [searchFn]="commonInputSearch"
              placeholder="Country *"
              required
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text "
                    class="form-control accordion-search search-input"
                    id="inputValidation "
                    (input)="select.filter($any($event.target).value)"
                    placeholder="Search... "
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item " let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || adminOrganizationForm.controls['country']?.touched) &&
                (adminOrganizationForm.controls['country']?.invalid ||
                  adminOrganizationForm.controls['country'].value?.name === 'Country')
              "
              class="input-error"
            >
              Country is required.
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <div class="services-form">
              <input
                maxlength="6"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number"
                min="10"
                formControlName="sessionTimeOut"
                placeholder="Session Timeout(Minutes)"
              />
              <label>Session timeout(minutes)</label>
              <div
                *ngIf="
                  (submitted || adminOrganizationForm.controls['sessionTimeOut']?.touched) &&
                  adminOrganizationForm.controls['sessionTimeOut'].errors
                "
              >
                <div
                  *ngIf="adminOrganizationForm.controls['sessionTimeOut'].errors?.['required']"
                  class="input-error"
                >
                  Session timeout is required
                </div>
                <div
                  *ngIf="adminOrganizationForm.controls['sessionTimeOut'].errors?.['min']"
                  class="input-error"
                >
                  Session timeout must be at least 10 minutes
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <div class="services-form">
              <textarea
                cols="20"
                formControlName="address"
                name="address"
                rows="2"
                placeholder="Address"
              ></textarea>
              <label>Address</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 currencyTab required">
          <div class="project-spacing currency-drpdown">
            <label *ngIf="sourceType" class="sub-header-drpdown pb-2"
              >Where did you hear about PIQET from?</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #sourceTypeDrp
              [items]="signUpSourceList"
              (change)="selectedSource($event)"
              [searchable]="false"
              bindLabel="name"
              formControlName="source"
              (clear)="clearSource()"
              [searchFn]="commonInputSearch"
              placeholder="Where did you hear about PIQET from? *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="sourceTypeDrp.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div
            *ngIf="submitted && adminOrganizationForm.get('source')?.invalid"
            class="input-error"
          >
            {{ 'Please select an option' }}
          </div>
        </div>

        <div class="col-4 required" *ngIf="showCommentBox">
          <label for="Comment" class="sub-header-drpdown pb-2">{{ labelText }}</label>
          <div class="services-form comment-box">
            <textarea
              formControlName="sourceComment"
              cols="20"
              id="Comment"
              name="Comment"
              rows="2"
              placeholder="Comment "
            ></textarea>
          </div>
          <div
            *ngIf="submitted && adminOrganizationForm.get('sourceComment')?.invalid"
            class="input-error"
          >
            Please add your comment
          </div>
        </div>
      </div>
    </form>
    <!-- <div class="text-brand" *ngIf="licenseMessage">
            <span>{{licenseMessage}}</span>
        </div> -->
  </div>
  <div class="modal-footer box-footer">
    <ng-container>
      <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
      <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
    </ng-container>
  </div>
</div>
